import React from 'react';

interface ArrowSlimLeftIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function ArrowSlimLeftIcon({
	width = 16,
	height = 16,
	fill = 'currentColor',
	...props
}: Readonly<ArrowSlimLeftIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#arrow_slim_left)">
				<path
					d="M4.05715 7.66617L4.06003 7.65708C4.13698 7.40306 4.28814 7.14037 4.51347 6.91058L9.46962 1.85627C9.76136 1.55875 10.104 1.39084 10.4098 1.3463C10.715 1.30182 10.9601 1.38041 11.1169 1.54038C11.2745 1.70102 11.3526 1.95354 11.3086 2.26806C11.2645 2.58238 11.0989 2.93289 10.8072 3.23037L6.39139 7.7336C6.24985 7.87795 6.24985 8.11052 6.39139 8.25487L10.8197 12.7709C11.1115 13.0684 11.2771 13.4189 11.3212 13.7332C11.3652 14.0478 11.287 14.3003 11.1295 14.4609C10.9726 14.6209 10.7276 14.6995 10.4223 14.655C10.1166 14.6105 9.77394 14.4426 9.4822 14.145L4.52605 9.09073C4.36154 8.92295 4.23618 8.73723 4.15055 8.54972C4.14283 8.53281 4.13386 8.51651 4.12371 8.50097C4.01099 8.3283 3.9668 8.07991 4.02691 7.78762L4.0284 7.77948C4.03564 7.73983 4.04528 7.70202 4.05715 7.66617Z"
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id="arrow_slim_left">
					<rect width={16} height={16} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
